var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    id: "Subscription--Streamline-Flex",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Subscription Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subscription--recurring-renewal-plan",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6 8.355a5.75 5.75 0 0 1 9.8 -4.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.6v2.75h-2.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1 8.355a5.75 5.75 0 0 1 -9.8 4.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2 15.1v-2.75h2.75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionStreamlineFlex);
export default __webpack_public_path__ + "static/media/Subscription--Streamline-Flex.a36ca991c6ca5e42818d6dc0dab8eaed.svg";
export { ForwardRef as ReactComponent };